export const createHeadline = ({ headlineTitle }) => headlineTitle || 'Measure Service';
